import { FunnelChart } from './FunnelChart';

export { FunnelChart } from './FunnelChart';
/**
 * @deprecated funnel chart is now stable, import `FunnelChart` instead
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const Unstable_FunnelChart = FunnelChart;
export type { FunnelChartProps, FunnelSeries } from './FunnelChart';
export * from './FunnelPlot';
export * from './funnelPlotSlots.types';
export * from './FocusedFunnelSection';
export * from './funnel.types';
export * from './categoryAxis.types';
export * from './funnelSlots.types';
export * from './FunnelChart.plugins';
export type { FunnelCurveType } from './curves';
export { funnelClasses } from './funnelClasses';
export type { FunnelClassKey, FunnelClasses } from './funnelClasses';
export { FunnelSection } from './FunnelSection';
export { FunnelSectionLabel } from './FunnelSectionLabel';
